import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import WeekView from './components/WeekView';
import MonthView from './components/MonthView';
import RecipesView from './components/RecipesView';
import { ThemeProvider } from './context/ThemeContext';
import './App.css';

function App() {
  return (
    <ThemeProvider>
      <div className="app">
        <Router>
          <Layout>
            <Routes>
              <Route path="/" element={<Navigate to="/semana" replace />} />
              <Route path="/semana" element={<WeekView />} />
              <Route path="/mes" element={<MonthView />} />
              <Route path="/recetas" element={<RecipesView />} />
            </Routes>
          </Layout>
        </Router>
      </div>
    </ThemeProvider>
  );
}

export default App;
